module.exports = __webpack_public_path__ + "static/media/turkey-guacamole.1a0bb3f1.jpg";